var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetupGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5C10.0376 12.5 12.5 10.0376 12.5 7C12.5 3.96243 10.0376 1.5 7 1.5C3.96243 1.5 1.5 3.96243 1.5 7C1.5 10.0376 3.96243 12.5 7 12.5Z",
    stroke: "#0C66E4",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.50176C5.62438 5.17757 5.85737 4.90658 6.15924 4.735C6.46111 4.56342 6.81315 4.50188 7.15532 4.56088C7.4975 4.61987 7.80861 4.79575 8.03559 5.05851C8.26257 5.32127 8.39136 5.65464 8.4 6.00176C8.4 7.00176 7 7.50176 7 8.50176",
    stroke: "#0C66E4",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00039 10.5984C7.33176 10.5984 7.60039 10.3298 7.60039 9.99844C7.60039 9.66707 7.33176 9.39844 7.00039 9.39844C6.66902 9.39844 6.40039 9.66707 6.40039 9.99844C6.40039 10.3298 6.66902 10.5984 7.00039 10.5984Z",
    fill: "#0C66E4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupGuide);
export default __webpack_public_path__ + "static/media/setupGuide.d784e6d5b7b849a6ba8bc48e00f409d6.svg";
export { ForwardRef as ReactComponent };